import { apiClient } from "../apiClient";

export const NOTIFICATION_ENDPOINT = "thong-bao";

export const notificationApi = {
  // Danh sách thông báo (phân trang) + tổng/số chưa đọc.
  Select: (page_index: number, page_size: number, read_status: "all" | "unread") =>
    apiClient.get(
      `${NOTIFICATION_ENDPOINT}?page_index=${page_index}&page_size=${page_size}&read_status=${read_status}`,
    ),
  // Đánh dấu đã đọc 1 thông báo.
  MarkRead: (id: number) =>
    apiClient.post(`${NOTIFICATION_ENDPOINT}/${id}/doc`, {}),
  // Đánh dấu đã đọc tất cả.
  MarkAllRead: () =>
    apiClient.post(`${NOTIFICATION_ENDPOINT}/doc-tat-ca`, {}),
  // Xử lý thông báo (vd tổng hợp lại học phí tín chỉ cho SV).
  XuLy: (id: number, process_id: string) =>
    apiClient.post(
      `${NOTIFICATION_ENDPOINT}/${id}/xu-ly?process_id=${process_id}`,
      {},
    ),
  // Bỏ qua thông báo.
  BoQua: (id: number) =>
    apiClient.post(`${NOTIFICATION_ENDPOINT}/${id}/bo-qua`, {}),
  // Danh sách SV của thông báo gộp.
  GetSinhViens: (id: number) =>
    apiClient.get(`${NOTIFICATION_ENDPOINT}/${id}/sinh-vien`),
};
